import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class BigStarIcon extends AbstractIcon {
  static selector = "big-star-icon"

  getHTML() {
    return `<svg viewBox="0 0 295 293" xmlns="http://www.w3.org/2000/svg">
        <path d="M147.5 0L158.523 74.4841L191.099 6.54517L179.589 80.9562L230.823 25.599L197.804 93.3252L263.144 55.4686L211.549 110.492L285.189 93.4998L219.603 130.932L295 136.313L221.25 152.827L291.705 180.105L216.345 174.235L275.597 220.984L205.323 193.25L248.107 255.318L189.162 208.185L211.677 280.056L169.299 217.712L169.546 293L147.5 220.984L125.455 293L125.701 217.712L83.3228 280.056L105.839 208.185L46.8933 255.318L89.6784 193.25L19.4031 220.984L78.6557 174.235L3.29487 180.105L73.7501 152.827L0 136.313L75.3976 130.932L9.81107 93.4998L83.4517 110.492L31.8566 55.4686L97.1964 93.3252L64.1774 25.599L115.412 80.9562L103.902 6.54517L136.478 74.4841L147.5 0Z">
        </path>
      </svg>`;
  }
}

componentsRegistryService.define(BigStarIcon);